var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.$emit('click-action')}}},[_c('span',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('span',{attrs:{"id":"value"}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }